import { useEffect, useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import i18n from "i18next";
import { Box, MenuItem, Stack, IconButton, Popover } from '@mui/material';
import EnglishIcon from 'assets/images/icons/ic_flag_en.svg';
import GermanIcon from 'assets/images/icons/ic_flag_de.svg';
// ----------------------------------------------------------------------

const LANGS = 
  {
    'en' : {
        label: 'English',
        icon: EnglishIcon,
    },
    'de' : {
        label: 'German',
        icon: GermanIcon,
    },
  };


// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const [open, setOpen] = useState(null);
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  console.log("i18 lang " + i18n.language)

  function getLang(lang) {
      if (lang in LANGS) {
          return LANGS[lang]
      } else {
        // if we get language that doesn't exist we set English
          setCurrentLanguage('en');
          i18n.changeLanguage('en');
          return LANGS['en']
      }
  }

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };
  const handleChangeLanguage = (lang) => {
    setCurrentLanguage(lang);
    i18n.changeLanguage(lang);
    handleClose();
  }
  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
          }),
        }}
      >
        <img src={getLang(currentLanguage).icon} alt={getLang(currentLanguage).label} />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Stack spacing={0.75}>
          {Object.keys(LANGS).map((lang) => (
            <MenuItem key={lang} value={lang} selected={lang === currentLanguage} onClick={() => handleChangeLanguage(lang)}>
              <Box component="img" alt={getLang(lang).label} src={getLang(lang).icon} sx={{ width: 28, mr: 2 }} />
              {getLang(lang).label}
            </MenuItem>
          ))}
        </Stack>
      </Popover>
    </>
  );
}